import { render, staticRenderFns } from "./LoginAsUser.vue?vue&type=template&id=52e13d77&"
import script from "./LoginAsUser.vue?vue&type=script&lang=js&"
export * from "./LoginAsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports